
// src/actions/sidebar.js

export const OPEN_SIDEBAR = "OPEN_SIDEBAR"
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR"
export const DOCK_SIDEBAR = "DOCK_SIDEBAR"
export const UNDOCK_SIDEBAR = "UNDOCK_SIDEBAR"

export function openSidebar() {
  return {
    type: OPEN_SIDEBAR
  }
}

export function closeSidebar() {
  return {
    type: CLOSE_SIDEBAR
  }
}

export function dockSidebar() {
  return {
    type: DOCK_SIDEBAR
  }
}

export function undockSidebar() {
  return {
    type: UNDOCK_SIDEBAR
  }
}



// WEBPACK FOOTER //
// ./src/actions/sidebar.js